import { render, staticRenderFns } from "./carchargerule.vue?vue&type=template&id=24ed63ac&"
import script from "./carchargerule.vue?vue&type=script&lang=js&"
export * from "./carchargerule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports